import { render, staticRenderFns } from "./NavBarFooter.vue?vue&type=template&id=645fa0c0&scoped=true"
import script from "./NavBarFooter.vue?vue&type=script&lang=js"
export * from "./NavBarFooter.vue?vue&type=script&lang=js"
import style0 from "./NavBarFooter.vue?vue&type=style&index=0&id=645fa0c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645fa0c0",
  null
  
)

export default component.exports